import React, { useEffect, useState } from "react"
import {
    Modal,
    ModalTitle,
    TitleSection,
    ContentSection,
    FooterSection,
    Label,
    Button,
    Row,
    Column,
    Color,
    Input,
} from "trux"
import { useHistory } from "react-router-dom"
import { useSelector } from "react-redux"
import { DetailsForm } from "./RosterInvite/DetailsForm"
import { validateEmail, validatePhone } from "../../util/helpers"
import { updatePlayer } from "./actions"

export const EditFamilyMemberModal = (props) => {
    const [setup, setSetup] = useState(false)
    const history = useHistory()
    const user_id = props.match.params.user_id
    const family = useSelector((state) => state.family)
    let familyMember

    for (let member of family.value) {
        if (member.user_id === parseInt(user_id)) familyMember = member
    }
    console.log("family", familyMember)

    const handleCloseButtonClick = (e) => {
        e.preventDefault()
        history.goBack()
    }

    useEffect(() => {
        if (familyMember) {
            setSetup(true)
            setName(familyMember.user.first_name)
            setEmail(familyMember.user.email)
        }
    }, [familyMember])

    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [number, setNumber] = useState("")
    const [errors, setErrors] = useState({
        name: null,
        email: null,
        phone: null,
        ready: true,
    })

    const validate = () => {
        var nameError = null
        var emailError = null
        var phoneError = null
        var ready = true

        if (name.length === 0) {
            nameError = "A family member must have a name"
        }

        if (email.length === 0) {
            emailError = "A family member must have an email"
        } else if (!validateEmail(email)) {
            emailError = "Invalid email"
        }

        if (number.length != 0 && !validatePhone(number)) {
            phoneError = "Invalid phone number"
        }

        if (nameError || emailError || phoneError) {
            ready = false
        }

        setErrors({
            name: nameError,
            email: emailError,
            phone: phoneError,
            ready: ready,
        })

        return ready
    }

    const onSave = () => {
        if (validate()) {
            updatePlayer(user_id, { email: email })
            history.goBack()
        }
    }
    return (
        <Modal
            className="RemoveFamily"
            open
            onShadeClick={(e) => {
                handleCloseButtonClick(e)
            }}
        >
            {setup && (
                <>
                    <TitleSection onCloseClick={handleCloseButtonClick}>
                        <ModalTitle content={familyMember.user.first_name} />
                    </TitleSection>
                    <ContentSection>
                        <Column center span="12" className="form">
                            <Input
                                type={Input.Type.Name}
                                label={
                                    <Row>
                                        <Label
                                            type={Label.Type.SmallBody}
                                            content="Full name"
                                            marginRight="1"
                                        />{" "}
                                        <Label
                                            type={Label.Type.SmallBody}
                                            content="*"
                                            color={Color.Error}
                                        />
                                    </Row>
                                }
                                value={name}
                                onChange={(e) => setName(e)}
                                error={errors.name}
                            />
                            <Input
                                type={Input.Type.Email}
                                label={
                                    <Row>
                                        <Label
                                            type={Label.Type.SmallBody}
                                            content="Email"
                                            marginRight="1"
                                        />{" "}
                                        <Label
                                            type={Label.Type.SmallBody}
                                            content="*"
                                            color={Color.Error}
                                        />
                                    </Row>
                                }
                                value={email}
                                onChange={(e) => setEmail(e)}
                                error={errors.email}
                            />
                            <Input
                                type={Input.Type.Text}
                                label={
                                    <Label
                                        type={Label.Type.SmallBody}
                                        content="Phone"
                                    />
                                }
                                value={number}
                                onChange={(e) => setNumber(e)}
                                error={errors.phone}
                                marginBottom="7"
                            />
                        </Column>
                    </ContentSection>
                </>
            )}

            <FooterSection>
                <Row width="100%">
                    <Button
                        width="100%"
                        className="button"
                        content={"Save changes"}
                        onClick={onSave}
                    />
                </Row>
            </FooterSection>
        </Modal>
    )
}
